<template>
  <div class="step">
    <div v-if="$slots.subheader || $slots.header" class="step-header" ref="stepHeaderRef">
      <p v-if="$slots.subheader" class="subheader">
        <slot name="subheader"></slot>
      </p>
      <h1 v-if="$slots.header"><slot name="header"></slot></h1>
      <p v-if="$slots.postheader" class="postheader">
        <slot name="postheader"></slot>
      </p>
      <p v-if="$slots.hint" class="hint"><slot name="hint"></slot></p>
    </div>
    <div class="step-content" ref="stepContentRef">
      <div class="content" v-bind="$attrs" ref="contentRef">
        <slot></slot>
      </div>
    </div>
    <div class="step-btns" ref="stepButtonsRef">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = defineProps({
  id: {
    type: String,
    default: "",
    required: false,
  },
});

const stepContentRef = ref<HTMLDivElement | null>(null);
const contentRef = ref<HTMLDivElement | null>(null);
const stepHeaderRef = ref<HTMLDivElement | null>(null);
const stepButtonsRef = ref<HTMLDivElement | null>(null);

defineExpose({
  props,
  contentRef,
  stepContentRef,
  stepHeaderRef,
  stepButtonsRef,
});
</script>

<style lang="scss" scoped>
.step {
  background: white;
  width: 100%;
  height: 100%;
  .step-header {
    margin-bottom: 0;
    width: 85%;
    margin: 0 auto;
    .subheader,
    .postheader {
      color: #767676;
      text-transform: uppercase;
      margin: 0;
    }

    .hint {
      margin-top: 0;
    }

    h1 {
      margin: 0;
      font-size: 1.5rem;
      width: 85%;
      height: -moz-fit-content;
      height: fit-content;
      // margin: 0 auto;
      padding-top: 10px;
    }
  }

  .step-content {
    width: 100%;
    min-height: 20%;
    max-height: 100%;
    overflow-y: hidden;
    overflow-x: hidden;
    margin-bottom: 2rem;

    &.overflow-y-auto {
      overflow-y: auto;
    }
    .content {
      width: 85%;
      height: fit-content;
      margin: 0 auto;
      padding-top: 10px;
    }
  }

  .step-btns {
    width: 85%;
    margin: 0 auto;
    text-align: center;
    padding-bottom: 16px;
  }
}

.step .stepBtns-flex-end .step-btns {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
}
// Small and medium devices (landscape phones,tablets 992px and down)
@media (max-width: 992px) {
  .step {
    .step-header {
      width: 90%;
      max-height: none;
      margin-bottom: 10px;
      margin: 0 auto;
    }
    // .step-header {
    //   margin: 10px 0;
    // }
    h1 {
      // font-size: 1.5em;
      font-size: 1.375rem;
      width: 90%;
      height: -moz-fit-content;
      height: fit-content;
      margin: 0 auto;
      padding-top: 10px;
    }

    .step-content {
      width: 100%;
      max-height: 75%;
      overflow-x: hidden;

      .content {
        width: 90%;
      }
    }

    .step-content {
      .content {
        height: fit-content;
      }
    }

    .step-btns {
      width: 100%;
      margin: 10px 0;
    }
  }
}

@media (max-width: 480px) {
	.step .step-header {
		width: 100%;
	}
  .step .step-content .content {
    width: 100%;
  }
}
</style>
